export default __webpack_public_path__ + "static/media/phone-number-screen.cd1b3d07.svg";